export default __webpack_public_path__ + "static/media/incorrect5.da7ce7c3.mp3";